// @ts-check
import React from 'react'
import cn from 'classnames'
import styles from './style.css'

/**
 * @param {{
 * onClick: {(event: React.MouseEvent): void},
 * children?: React.ReactNode,
 * className?: string }} props
 */
const ButtonLink = ({ onClick, children, className }) => {
  return (
    <button type='button' className={cn(styles.buttonLink, className)} onClick={onClick}>
      {children}
    </button>
  )
}

export { ButtonLink }
